import { useEffect } from 'react';
import { Navigate } from 'react-router';
import { Box, Typography } from '@mui/material';
import FirmGuardrails from '../components/Settings/FirmGuardrails';
import { useIRWorkstation } from '../contexts/IRWorkstationContext';
import { useTrackEvent } from 'hooks/useTrackEvent';
import { useUserContext } from 'contexts/UserContext';
import { PageLoadsTargets } from 'constants/pageLoadTargets';

const Settings = () => {
	const { tenant, featureFlags } = useIRWorkstation();
	const { user } = useUserContext();
	const { trackPageLoad } = useTrackEvent({
		tenant,
		product: 'IEM',
	});

	const canAccessSettings = user?.role === 'tenant_admin';

	const isGuardrailsEnabled =
		featureFlags?.['enable-draft-outreach-prompt'] !== false;

	useEffect(() => {
		if (canAccessSettings) {
			trackPageLoad(PageLoadsTargets.Settings);
		}
	}, []);

	if (!canAccessSettings) {
		return <Navigate to='..' replace />;
	}

	return (
		<Box
			sx={{
				flex: 1,
				minWidth: 0,
				overflowY: 'auto',
				backgroundColor: 'background.default',
				padding: '12px 20px',
				display: 'flex',
				flexDirection: 'column',
				gap: '14px',
			}}
		>
			{/* Page header */}
			<Box
				sx={{
					display: 'flex',
					alignItems: 'baseline',
					justifyContent: 'space-between',
				}}
			>
				<Box>
					<Typography variant='h1' sx={{ fontSize: '17px', fontWeight: 700 }}>
						Settings
					</Typography>
				</Box>
			</Box>

			{isGuardrailsEnabled && <FirmGuardrails />}
		</Box>
	);
};

export default Settings;
